// src/components/store/sections/testimonials/TestimonialV24GlassfloatingTealLagoon.tsx
"use client";

import React from "react";
import DynamicTestimonialVariant from "./DynamicTestimonialVariant";

export default function TestimonialV24GlassfloatingTealLagoon(props: any) {
  return (
    <DynamicTestimonialVariant
      variantNumber={24}
      archKey="glass_floating"
      archLabel="Frosted Glass Reviews"
      palName="TealLagoon"
      grad="from-teal-500 via-cyan-600 to-emerald-700"
      lightBg="bg-teal-50"
      textCol="text-teal-700"
      borderCol="border-teal-200"
      btnCls="bg-teal-600 hover:bg-teal-700"
      hexCol="#14b8a6"
      {...props}
    />
  );
}
